export default __webpack_public_path__ + "static/media/savedchat_empty_state.38cb9d4b.svg";